<template>
    <!-- Panel de la tarjeta (demo: js/drawer.js). Izquierda la ficha (estado,
         prioridad, asignada, seguimiento, contacto); derecha las pestañas
         Resumen · Notas e historial · Datos. ← → pasa de tarjeta, Esc cierra. -->
    <div class="cr-dr" :class="{ 'is-closing': cerrando }" @keydown="tecla">
        <div class="cr-dr-bg" @click="cerrar"></div>
        <aside v-if="c" ref="card" class="cr-dr-card" role="dialog" aria-modal="true" aria-labelledby="crDrT" tabindex="-1">
            <div class="cr-dr-bar">
                <span class="cr-dr-nav">
                    <button type="button" class="cr-ico-btn" :disabled="pos.i <= 0" :aria-label="t('dr.prev')" @click="ir(-1)" v-html="I.left"></button>
                    <button type="button" class="cr-ico-btn" :disabled="pos.i < 0 || pos.i >= pos.ids.length - 1" :aria-label="t('dr.next')" @click="ir(1)" v-html="I.right"></button>
                </span>
                <span v-if="pos.i >= 0" class="cr-tag">{{ t('dr.pos', { a: pos.i + 1, b: pos.ids.length }) }}</span>
                <span class="cr-dr-bar-hint">{{ t('dr.hint') }}</span>
                <button type="button" class="cr-ico-btn" data-x :aria-label="t('close')" @click="cerrar" v-html="I.close"></button>
            </div>
            <div class="cr-dr-split">
                <aside class="cr-dr-info" :aria-label="t('dr.sheet')">
                    <div class="cr-dr-id"><span v-html="crm.priPill(c.prioridad)"></span><span v-html="crm.estPill(c.estado)"></span></div>
                    <h2 id="crDrT" class="cr-dr-title">{{ c.empresa }}</h2>
                    <p class="cr-dr-meta">{{ c.tipo || t('dr.no_type') }}</p>
                    <ul v-if="ciudades.length" class="cr-dr-cities" :aria-label="t('fld.ciudades')"><li v-for="x in ciudades" :key="x"><span v-html="I.pin"></span>{{ x }}</li></ul>
                    <dl class="cr-dr-props">
                        <dt><span v-html="I.move"></span>{{ t('p.state') }}</dt>
                        <dd><button type="button" class="cr-prop-dd" aria-haspopup="listbox" aria-expanded="false" :aria-label="t('p.state')" @click="crm.ddTarjeta($event, c, 'estado')"><span v-html="crm.estPill(c.estado)"></span><span class="cr-chev" v-html="I.chev"></span></button></dd>
                        <dt><span v-html="I.flag"></span>{{ t('p.pri') }}</dt>
                        <dd><button type="button" class="cr-prop-dd" aria-haspopup="listbox" aria-expanded="false" :aria-label="t('p.pri')" @click="crm.ddTarjeta($event, c, 'pri')"><span v-html="crm.priPill(c.prioridad)"></span><span class="cr-chev" v-html="I.chev"></span></button></dd>
                        <dt><span v-html="I.user"></span>{{ t('p.asig') }}</dt>
                        <dd><button type="button" class="cr-prop-dd" aria-haspopup="listbox" aria-expanded="false" :aria-label="t('p.asig')" @click="crm.ddTarjeta($event, c, 'asig')"><span v-html="crm.whoHTML(c.asignado)"></span><span class="cr-chev" v-html="I.chev"></span></button>
                            <button v-if="c.asignado !== crm.yo" type="button" class="cr-btn-link" @click="crm.asignar(c, crm.yo)">{{ t('dr.mine') }}</button></dd>
                        <dt><span v-html="I.cal"></span>{{ t('p.follow') }}</dt>
                        <dd class="cr-dd-seg">
                            <input type="date" class="cr-date-in" :value="c.seguimiento" :aria-label="t('p.follow')" @change="crm.seguimiento(c, $event.target.value)" />
                            <template v-if="c.seguimiento"><button type="button" class="cr-btn-link" @click="crm.seguimiento(c, '')">{{ t('dr.remove') }}</button><span v-if="crm.segVencido(c)" class="cr-tag cr-tag--bad">{{ t('dr.due') }}</span></template>
                            <span v-else class="cr-dd-hint">{{ t('dr.follow_hint') }}</span>
                        </dd>
                    </dl>
                    <div class="cr-dr-contact">
                        <span class="cr-av cr-av--l" style="--av:linear-gradient(135deg,#6d3ce0,#B91E7C)" aria-hidden="true">{{ ini(c.contacto || c.empresa) }}</span>
                        <div><b>{{ c.contacto || t('card.no_contact') }}</b><small>{{ c.cargo || (c.contacto ? t('dr.no_role') : t('dr.general_mail')) }}</small></div>
                        <div v-if="links.length" class="cr-cd-links">
                            <a v-for="l in links" :key="l.k" class="cr-lk" :class="l.cls" :href="l.href" target="_blank" rel="noopener" :title="l.t" :aria-label="l.t" v-html="l.ic"></a>
                        </div>
                    </div>
                </aside>

                <section class="cr-dr-main">
                    <div class="cr-tabs" role="tablist">
                        <button v-for="(tb, i) in TABS" :key="tb" ref="tabs" type="button" class="cr-tab" role="tab" :aria-selected="String(crm.tabDetalle === tb)" @click="tab(tb)" @keydown="teclaTab($event, i)">
                            {{ t('dr.tab.' + tb) }}<span v-if="tb === 'historial' && c.nNotas" class="cr-n">{{ c.nNotas }}</span>
                        </button>
                    </div>
                    <div ref="body" class="cr-dr-body" role="tabpanel">
                        <!-- Resumen -->
                        <template v-if="crm.tabDetalle === 'resumen'">
                            <section class="cr-box"><h3><span v-html="I.clock"></span>{{ t('sum.times') }}</h3>
                                <dl class="cr-facts">
                                    <div class="cr-fact" :class="{ 'is-late': crm.edad(c).nivel === 'late' }"><dt>{{ t('sum.in', { e: est.nombre }) }}</dt><dd>{{ crm.edad(c).txt }}<small>{{ t('sum.since', { f: crm.fecha(c.estadoDesde) }) }}</small></dd></div>
                                    <div v-if="c.primerContacto" class="cr-fact" :class="c.primerContacto - c.creada > 7 * DAY ? 'is-late' : 'is-ok'"><dt>{{ t('sum.took') }}</dt><dd>{{ crm.durTxt(c.primerContacto - c.creada) }}<small>{{ crm.fecha(c.primerContacto) }}</small></dd></div>
                                    <div v-else-if="est.pend && !c.contactoPrevio" class="cr-fact" :class="{ 'is-late': crm.ahora - c.creada > 7 * DAY }"><dt>{{ t('sum.waiting') }}</dt><dd>{{ crm.durTxt(crm.ahora - c.creada) }}<small>{{ t('sum.since', { f: crm.fecha(c.creada, false) }) }}</small></dd></div>
                                    <div v-else class="cr-fact"><dt>{{ t('sum.took') }}</dt><dd>—<small>{{ t('sum.prev') }}</small></dd></div>
                                    <div class="cr-fact"><dt>{{ t('sum.last_move') }}</dt>
                                        <dd v-if="c.movida"><span class="cr-who-line"><span v-html="crm.avHTML(c.movidaPor, 'cr-av--s')"></span>{{ crm.nombreDe(c.movidaPor) }}</span><small>{{ crm.rel(c.movida) }}<template v-if="ultMov"> · {{ crm.estado(ultMov.de).nombre }} → {{ crm.estado(ultMov.a).nombre }}</template></small></dd>
                                        <dd v-else>—<small>{{ t('sum.never_moved') }}</small></dd></div>
                                    <div class="cr-fact"><dt>{{ t('sum.loaded') }}</dt><dd>{{ crm.fecha(c.creada, false) }}<small>{{ t('sum.by', { n: crm.nombreDe(c.creadaPor) }) }}</small></dd></div>
                                </dl>
                            </section>
                            <section class="cr-box"><h3><span v-html="I.user"></span>{{ t('sum.contact') }}</h3>
                                <div class="cr-links">
                                    <div v-for="f in filasContacto" :key="f.k" class="cr-link-row" :class="{ 'is-empty': !f.val }">
                                        <span :class="{ 'cr-in-ico': f.in }" v-html="f.ic"></span>
                                        <span class="cr-lr-t"><small>{{ f.t }}</small><span v-if="f.val" :title="f.val">{{ f.val }}</span><span v-else class="cr-muted">{{ t('sum.no_data') }}</span></span>
                                        <template v-if="f.val">
                                            <button type="button" class="cr-ico-btn" :aria-label="t('sum.copy', { c: f.t })" @click="copiar(f.copia)" v-html="I.copy"></button>
                                            <a v-if="f.href" class="cr-ico-btn" :href="f.href" target="_blank" rel="noopener" :aria-label="t('sum.open', { c: f.t })" v-html="I.ext"></a>
                                        </template>
                                        <button v-else type="button" class="cr-btn-link" style="margin-right:8px" @click="tab('datos', f.k)">{{ t('sum.add') }}</button>
                                    </div>
                                </div>
                            </section>
                        </template>

                        <!-- Notas e historial -->
                        <template v-else-if="crm.tabDetalle === 'historial'">
                            <section class="cr-box"><h3><span v-html="I.note"></span>{{ t('hist.new') }}</h3>
                                <div class="cr-composer">
                                    <label class="cr-sr" for="crNota">{{ t('hist.note') }}</label>
                                    <textarea id="crNota" ref="nota" v-model="notaTxt" :placeholder="t('hist.ph')" maxlength="2000" @keydown.ctrl.enter.prevent="guardarNota" @keydown.meta.enter.prevent="guardarNota"></textarea>
                                    <div class="cr-composer-row"><small>{{ t('hist.hint') }}</small><button type="button" class="cr-btn cr-btn-main cr-btn-sm" :disabled="!notaTxt.trim() || enviando" @click="guardarNota">{{ t('hist.save') }}</button></div>
                                </div>
                            </section>
                            <section class="cr-box"><h3><span v-html="I.clock"></span>{{ t('hist.title') }}</h3>
                                <div class="cr-tl-filter">
                                    <button v-for="k in ['', 'mov', 'nota', 'otros']" :key="k" type="button" class="cr-chip" :aria-pressed="String(filtroHist === k)" @click="filtroHist = k">{{ t('hist.f.' + (k || 'all')) }}</button>
                                </div>
                                <div v-if="cargandoHist && !historial" class="cr-tl-empty">{{ t('loading') }}</div>
                                <CrmTimeline v-else :items="itemsHist" />
                            </section>
                        </template>

                        <!-- Datos -->
                        <template v-else>
                            <section class="cr-box"><h3><span v-html="I.edit"></span>{{ t('data.title') }}</h3>
                                <CrmCampos ref="campos" v-model="form" :errores="errores" pref="dr" @enter="guardarDatos" />
                            </section>
                            <section class="cr-box"><div class="cr-danger-zone"><p>{{ t('data.del_p') }}</p>
                                <button type="button" class="cr-btn cr-btn-danger cr-btn-sm" @click="crm.eliminar(c)"><span v-html="I.trash"></span>{{ t('data.del') }}</button></div></section>
                            <div class="cr-form-bar">
                                <small>{{ enviando ? t('saving') : cambios.length ? tcx('data.dirty', cambios.length) : t('data.clean') }}</small>
                                <button type="button" class="cr-btn cr-btn-ghost" :disabled="!cambios.length" @click="descartar">{{ t('data.discard') }}</button>
                                <button type="button" class="cr-btn cr-btn-main" :disabled="!cambios.length || enviando" @click="guardarDatos">{{ t('data.save') }}</button>
                            </div>
                        </template>
                    </div>
                </section>
            </div>
        </aside>
    </div>
</template>

<script>
import axios from 'axios';
import CrmTimeline from './CrmTimeline.vue';
import CrmCampos, { CAMPOS, validar, erroresApi } from './CrmCampos.vue';
import { PILA } from './CrmModal.vue';
import { I, DAY, esc, iniciales, ciudadesDe, urlOk, dominio, copiar } from './crmUtil';

const TABS = ['resumen', 'historial', 'datos'];
const datosDe = c => { const o = {}; CAMPOS.forEach(f => { o[f.k] = c[f.k] || ''; }); return o; };

export default {
    name: 'CrmDrawer',
    components: { CrmTimeline, CrmCampos },
    inject: ['crm'],
    data() {
        return { I, DAY, TABS, cerrando: false, historial: null, cargandoHist: false, filtroHist: '', notaTxt: '', enviando: false, form: {}, errores: {} };
    },
    computed: {
        c() { return this.crm.tarjeta(this.crm.abiertaId); },
        est() { return this.crm.estado(this.c.estado); },
        ciudades() { return ciudadesDe(this.c); },
        pos() {
            const ids = this.crm.vista === 'lista' && this.crm.$refs.list ? this.crm.$refs.list.filas.map(x => x.id)
                : [].concat(...this.crm.estados.filter(e => !this.crm.plegadas.includes(e.id)).map(e => this.crm.enColumna(e.id).map(x => x.id)));
            return { ids, i: ids.indexOf(this.crm.abiertaId) };
        },
        links() {
            const c = this.c, t = this.t;
            return [
                urlOk(c.web) && { k: 'w', href: urlOk(c.web), ic: I.web, t: t('fld.web') },
                c.email && { k: 'm', href: 'mailto:' + c.email, ic: I.mail, t: t('fld.email') },
                urlOk(c.liP) && { k: 'p', href: urlOk(c.liP), ic: I.in, t: t('fld.liP'), cls: 'cr-lk--in' },
                urlOk(c.liE) && { k: 'e', href: urlOk(c.liE), ic: I.in, t: t('fld.liE'), cls: 'cr-lk--in' },
            ].filter(Boolean);
        },
        filasContacto() {
            const c = this.c, t = this.t;
            return [
                { k: 'email', t: t('fld.email'), ic: I.mail, val: c.email, copia: c.email, href: c.email ? 'mailto:' + c.email : '' },
                { k: 'web', t: t('fld.web'), ic: I.web, val: c.web ? dominio(c.web) : '', copia: c.web, href: urlOk(c.web) },
                { k: 'liP', t: t('fld.liP'), ic: I.in, in: true, val: c.liP, copia: c.liP, href: urlOk(c.liP) },
                { k: 'liE', t: t('fld.liE'), ic: I.in, in: true, val: c.liE, copia: c.liE, href: urlOk(c.liE) },
            ];
        },
        ultMov() { return (this.historial || []).filter(h => h.ty === 'mov').pop(); },
        itemsHist() {
            const f = this.filtroHist;
            return (this.historial || []).filter(h => !f || (f === 'otros' ? !['mov', 'nota'].includes(h.ty) : h.ty === f)).slice().reverse();
        },
        cambios() { return this.c ? CAMPOS.filter(f => (this.c[f.k] || '') !== (this.form[f.k] || '').trim()) : []; },
        sucio() { return this.crm.tabDetalle === 'datos' && this.cambios.length > 0; },
    },
    watch: {
        'crm.abiertaId': { immediate: true, handler(id, viejo) {
            if (!id) return;
            this.historial = null; this.notaTxt = ''; this.errores = {};
            this.form = datosDe(this.c);
            this.cargarHistorial();
            this.$nextTick(() => {
                if (!viejo && this.$refs.card) { this._prev = document.activeElement; this.$refs.card.focus(); }
                if (this.$refs.body) this.$refs.body.scrollTop = 0;
                if (this.crm.$refs.list) this.crm.$refs.list.marcar(id);
            });
        } },
        c(nueva, vieja) { if (nueva && vieja && nueva.id === vieja.id && !this.cambios.length) this.form = datosDe(nueva); },
    },
    mounted() {
        // Esc a nivel de documento (el foco puede no estar dentro del panel), salvo
        // que haya una ventana o un desplegable abiertos encima.
        this._esc = e => {
            if (e.key !== 'Escape' || PILA.length || document.querySelector('.cr-pop')) return;
            e.preventDefault(); this.cerrar();
        };
        document.addEventListener('keydown', this._esc);
    },
    beforeDestroy() { document.removeEventListener('keydown', this._esc); },
    methods: {
        t(k, p) { return this.crm.t(k, p); },
        tcx(k, n) { return this.crm.tc(k, n); },
        ini: iniciales,
        async cargarHistorial() {
            const id = this.crm.abiertaId; if (!id) return;
            this.cargandoHist = true;
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_API_URL}admin/crm-anfitriones/${id}`);
                if (id === this.crm.abiertaId) { this.historial = data.historial || []; this.crm.reemplazar(data.tarjeta); }
            } catch (e) { if (id === this.crm.abiertaId && !this.historial) this.historial = []; }
            this.cargandoHist = false;
        },
        async cerrar() {
            if (this.cerrando) return;
            if (this.sucio && !(await this.crm.confirmar({ titulo: this.t('dirty.t'), texto: this.t('dirty.p'), si: this.t('dirty.go'), peligro: true }))) return;
            this.cerrando = true;
            const id = this.crm.abiertaId, prev = this._prev;
            setTimeout(() => {
                this.crm.cerrarDetalle();
                this.$nextTick(() => {
                    const el = document.querySelector(`.cr-cd[data-id="${id}"], .cr-xl tr[data-id="${id}"]`) || prev;
                    if (el && el.isConnected) el.focus();
                });
            }, 210);
        },
        ir(d) { const n = this.pos.ids[this.pos.i + d]; if (n) this.crm.abrir(n, this.crm.tabDetalle); },
        async tab(tb, campo) {
            if (this.sucio && tb !== 'datos' && !(await this.crm.confirmar({ titulo: this.t('dirty.t'), texto: this.t('dirty.tab'), si: this.t('dirty.go'), peligro: true }))) return;
            if (tb !== 'datos') { this.form = datosDe(this.c); this.errores = {}; }
            this.crm.tabDetalle = tb;
            this.$nextTick(() => {
                if (this.$refs.body) this.$refs.body.scrollTop = 0;
                if (campo && this.$refs.campos) this.$refs.campos.enfocar(campo);
                else if (tb === 'historial' && this.$refs.nota) this.$refs.nota.focus();
            });
        },
        teclaTab(e, i) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault(); e.stopPropagation();
            const j = (i + (e.key === 'ArrowRight' ? 1 : TABS.length - 1)) % TABS.length;
            this.tab(TABS[j]).then(() => this.$refs.tabs[j] && this.$refs.tabs[j].focus());
        },
        tecla(e) {
            if (e.key === 'Escape') return;
            if (e.key === 'Tab' && this.$refs.card) {
                const f = [...this.$refs.card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, [tabindex="0"]')].filter(x => x.offsetParent !== null);
                if (!f.length) return;
                const a = f[0], z = f[f.length - 1];
                if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
                else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
                return;
            }
            if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !e.shiftKey && !/INPUT|TEXTAREA|SELECT/.test(e.target.tagName) && !e.target.closest('.cr-tab')) {
                e.preventDefault(); this.ir(e.key === 'ArrowRight' ? 1 : -1);
            }
        },
        copiar(txt, msg) {
            copiar(txt).then(() => this.crm.toast(esc(msg || this.t('toast.copied'))), () => this.crm.toast(esc(this.t('error.copy')), null, null, true));
        },
        async guardarNota() {
            const txt = this.notaTxt.trim(); if (!txt || this.enviando) return;
            this.enviando = true;
            try { await this.crm.nota(this.c, txt); this.notaTxt = ''; await this.cargarHistorial(); this.$nextTick(() => this.$refs.nota && this.$refs.nota.focus()); }
            catch (e) { this.crm.fallo(e); }
            this.enviando = false;
        },
        descartar() { this.form = datosDe(this.c); this.errores = {}; },
        async guardarDatos() {
            const err = validar(this.form);
            this.errores = err;
            if (Object.keys(err).length) { this.$refs.campos.enfocar(Object.keys(err)[0]); return; }
            if (!this.cambios.length || this.enviando) return;
            const datos = {}; this.cambios.forEach(f => { datos[f.k] = (this.form[f.k] || '').trim(); });
            this.enviando = true;
            try { await this.crm.editar(this.c, datos); this.form = datosDe(this.c); this.cargarHistorial(); }
            catch (e) {
                const api = erroresApi(e);
                if (api) { this.errores = api; this.$refs.campos.enfocar(Object.keys(api)[0]); } else this.crm.fallo(e);
            }
            this.enviando = false;
        },
    },
};
</script>
